/** レーンは DB の `lane_name`（例: Mid Lane）で比較する */
export function filterHeroesByLane<T extends { lanes: string[] }>(
  heroes: T[],
  laneFilter: 'all' | string
): T[] {
  if (laneFilter === 'all') return heroes;
  return heroes.filter((h) => h.lanes.includes(laneFilter));
}
